import * as React from 'react';
import { Chip, lighten, useTheme } from '@material-ui/core';
import CheckIcon from '@material-ui/icons/Check';

interface ChipSelectProps {
  label: string;
  selected: boolean;
  disabled?: boolean;
  customIcon?: React.ReactElement
  handleClick: () => void;
}

const ChipSelect: React.FC<ChipSelectProps> = ({
  label, selected, disabled, customIcon, handleClick,
}) => {
  const theme = useTheme();
  return (
    <Chip
      style={selected ? { backgroundColor: lighten(theme.palette.primary.light, 0.75) } : { paddingLeft: 11, paddingRight: 11 }}
      deleteIcon={selected
        ? customIcon || <CheckIcon />
        : <></>}
      variant="outlined"
      color={selected ? 'primary' : 'default'}
      label={label}
      onDelete={() => handleClick()}
      onClick={() => handleClick()}
      id={`${label?.replaceAll(' ', '-').toLowerCase()}-chip-select`}
      disabled={disabled}
    />
  );
};

export default ChipSelect;
